<!--
 * @Descripttion: 
 * @version: 
 * @Author: mrh
 * @Date: 2020-07-24 09:16:37
 * @LastEditors: mrh
 * @LastEditTime: 2021-03-10 09:59:22
--> 
<template>
  <div class="searchconter">
    <div class="searchs">
      <van-icon name="arrow-left return" @click="closeHandsel" />
      <van-search
        v-model="searchVal"
        shape="round"
        placeholder="请输入商品名称"
        background="#fff"
        @search="searchProduct(searchVal)"
        @input="inputs"
      />
    </div>
    <transition name="van-fade">
      <div class="record" v-show="showRecord">
        <div class="hots" v-show="hotData.length > 0">
          <p>
            <span>热门搜索</span>
          </p>
          <div>
            <span
              v-for="(item, index) in hotData"
              :key="index"
              @click="searchProduct(item.keyword)"
              >{{ item.keyword }}</span
            >
          </div>
        </div>
        <div class="history" v-show="historyData.length > 0">
          <p>
            <span>历史搜索</span>
            <i class="iconfont icon-home_tab_icon_trash" @click="remove()"></i>
          </p>
          <div>
            <span
              v-for="(item, index) in historyData"
              :key="index"
              @click="searchProduct(item)"
              >{{ item }}</span
            >
          </div>
        </div>
      </div>
    </transition>
    <transition name="van-fade">
      <div class="searchList" v-show="showSearchs">
        <div
          v-for="(item, index) in suggestList"
          :key="index"
          @click="searchProduct(item.suggestion)"
        >
          <span>{{ item.suggestionB }}</span>
          <span class="searchVal">{{ item.suggestionC }}</span>
          <span>{{ item.suggestionA }}</span>
        </div>
      </div>
    </transition>
    <div
      @click="showRecord = false"
      class="listDiv"
      v-show="searchData.length > 0"
    >
      <goods-list :list-data="searchData">
        <template v-slot:countDowm="{ item }">
          <div style="display: flex; align-items: baseline">
            <!-- <van-count-down
              :time="item.fastSelling.countDown * 1000"
              v-show="item.fastSelling.countDown > 0 && item.type == 3"
              format="距结束 DD天HH:mm:ss"
            /> -->
            <span class='times' v-show="item.fastSelling.countDown > 0 && item.type == 3">结束时间 {{item.countDowm}}</span>
          </div>
          <!--  -->
        </template>
        <template v-slot:recommend="{ item }">
          <div>
            <p>
              <span>￥{{ item.price }}</span>
              <span>{{ item.guidePrice }}</span>
              <span class="shopMoney">佣金{{ item.communityShopMoney }}</span>
            </p>
          </div>
        </template>
        <template v-slot:tj="{ item }">
          <div class="btn_group">
            <van-button
              color="#208FFF"
              @click.stop="getGoodsDesc(item.spgExId)"
              class="copy"
              v-if="item.spgExId!=0"
              >复制推广文案</van-button
            >
            <van-button
              round
              block
              type="info"
              color="#FF9A34"
              @click.stop="
                recommendAdd(item.isRecommend, item.sellerProductGoodsId)
              "
              v-if="item.type == 2"
              :class="{ isRecommend: item.isRecommend == 1 }"
              >{{ item.isRecommend == 1 ? "取消推荐" : "推荐" }}</van-button
            >

            <span
              class="success"
              v-if="
                item.collageOrder.minNum - item.collageOrder.hadBoughtNum == 0 &&
                item.type == 4
              "
              >{{ item.collageOrder.hadBoughtNum }}</span
            >
            <span
              class="buyNums"
              v-if="
                item.collageOrder.minNum - item.collageOrder.hadBoughtNum > 0 &&
                item.type == 4
              "
              >{{
                item.collageOrder.minNum - item.collageOrder.hadBoughtNum
              }}</span
            >
            </div>
        </template>
      </goods-list>
    </div>

    <div v-show="isNull" class="nulls">
      <i class="icon-personal_image_nothi iconfont"></i>
      <p>暂无相关商品</p>
    </div>
    <div v-show="isLoading" class="nulls">
      <!-- <i class="icon-personal_image_nothi iconfont"></i> -->
      <!-- <p>暂无相关商品</p> -->
      <img src="../../assets/img/Lark20201202-143318.gif" alt="" />
    </div>
    <div id='copy-txt' v-html="description"></div>
  </div>
</template>
<script>
import {
  supplyOfGoods,
  searchProduct,
  getHotKeyword,
  recommendAdd,
  suggestSearch,
  getGoodsDesc,
} from "@/api/join";
import goodsList from "@/components/list/list";
import sharePopup from "@/components/share/share";
export default {
  components: {
    goodsList,
    sharePopup,
  },
  data() {
    return {
      // headerMsg: {},
      searchVal: "",
      hotData: [],
      historyData: [],
      searchData: [],
      showRecord: true,
      isNull: false,
      showSearchs: false, //搜索的联想列表是否展示
      suggestList: [], //联想列表
      isLoading: false,
      description: "",
    };
  },
  mounted() {
    //   获取热门搜索纪录
    this.getHotKeyword();
    this.setHistory();
  },
  methods: {
    // 时间戳转换
    set_time(str) {
      let t = Date.parse(new Date()) / 1000;
      let n = (parseInt(str) + t) * 1000;
      let D = new Date(n);
      // let year = D.getFullYear();//四位数年份

      let month = D.getMonth() + 1; //月份(0-11),0为一月份
      // month = month < 10 ? ('0' + month) : month;

      let day = D.getDate(); //月的某一天(1-31)
      day = day < 10 ? "0" + day : day;

      let hours = D.getHours(); //小时(0-23)
      hours = hours < 10 ? "0" + hours : hours;

      let minutes = D.getMinutes(); //分钟(0-59)
      minutes = minutes < 10 ? "0" + minutes : minutes;

      // var seconds = D.getSeconds();//秒(0-59)
      // seconds = seconds<10?('0'+seconds):seconds;
      // var week = D.getDay();//周几(0-6),0为周日
      // var weekArr = ['周日','周一','周二','周三','周四','周五','周六'];
      // this.setData({
      //   dates: `${month} 月 ${day} 日`,//年月
      //   hours,//小时
      //   minutes,//分
      //   times:`${month}月${day}日${hours}:${minutes}`
      // })
      let now_time = `${month}月${day}日${hours}:${minutes}`;
      console.log(now_time);
      return now_time;
    },
    // 搜索联想词接口
    inputs(val) {
      this.showSearchs = val.length > 0 ? true : false;
      suggestSearch({ suggest: val }).then((res) => {
        if (res.appStatus.errorCode == 0) {
          if (res.content.list.length > 0) {
            res.content.list.forEach((el) => {
              el.suggestionB = el.suggestion.split(this.searchVal)[0];
              el.suggestionC =
                el.suggestion.indexOf(this.searchVal) != -1
                  ? this.searchVal
                  : "";
              el.suggestionA = el.suggestion.split(this.searchVal)[1];
            });
          } else {
            res.content.list.push({
              suggestionB: this.searchVal,
              suggestionA: "",
              suggestionC: "",
              suggestion: this.searchVal,
            });
          }
          // console.log(res.content.list);
          this.suggestList = [];
          this.suggestList = res.content.list;
        }
      });
    },
    supplyOfGoods() {
      let obj = {
        cateId: "-1", //一级分类id，刚进入查找货源页面cateId传-1，后台拿去列表数据的时候按第一个分类id去拿，
      };
      supplyOfGoods(obj).then((res) => {
        // console.log(res)
        this.tabType = res.content.cateList;
        this.list = res.content.list;
      });
    },
    searchProduct(val) {
      if (val == "" || val == undefined) {
        this.$toast("请输入您想搜索的商品名称");
        return;
      }
      this.isLoading = true;
      this.isNull = false;
      this.searchVal = val;
      let obj = {
        keyword: val, //
        communityShopId: this.$store.getters.communityShopId,
        keyword: val, //
        page: {
          way: "0", // 0:不分页 1:分页
          index: "1", //请求页
          size: "100", //请求大小
        },
      };
      searchProduct(obj).then((res) => {
        // console.log(res);
        this.showSearchs = false;
        this.showRecord = false;
        this.setHistory(val);
        res.content.list.forEach((el) => {
            let states = Object.keys(el.collageOrder).length > 0 ? true : false;
            el.sharePromotionContent = !states
              ? el.fastSelling.sharePromotionContent
                ? el.fastSelling.sharePromotionContent
                : ""
              : "";
            if (el.countDown) {
                el.countDown = this.set_time(el.countDown);
              }else{
                el.countDown = states
              ? el.collageOrder.countDown
              : el.fastSelling.countDown;
              el.countDown = this.set_time(el.countDown);
              }
            el.minNum = states ? el.collageOrder.minNum : 0;
            el.hadBoughtNum = states ? el.collageOrder.hadBoughtNum : 0;
            // delete el.fastSelling;
            // delete el.collageOrder;
          });
        setTimeout(() => {
          this.searchData = res.content.list;
          this.isNull = res.content.list.length == 0 ? true : false;
          this.isLoading = false;
        }, 600);
      });
    },
    getHotKeyword() {
      getHotKeyword({}).then((res) => {
        this.hotData = res.content.list;
      });
    },

    // 存取本地历史纪录
    setHistory(val) {
      //   console.log(val);
      let datas = JSON.parse(localStorage.getItem("historyList")) || [];
      if (val == "" || val == undefined) {
        //   输入框不能为空
        this.historyData = datas.reverse().slice(0, 10);
        return;
      }
      //  过滤去重
      datas = datas.filter((el) => {
        return el != val;
      });
      datas.push(val);
      //   本地保存
      localStorage.setItem("historyList", JSON.stringify(datas));
      //   拿取历史纪录的前十位
      this.historyData = datas.reverse().slice(0, 9);
    },

    // 清除搜索的本地历史纪录
    remove() {
      this.$dialog
        .confirm({
          // title: "标题",
          message: "确定清空历史搜索？",
          confirmButtonColor: "#1993FF",
        })
        .then(() => {
          // on confirm
          localStorage.clear();
          this.setHistory();
        })
        .catch(() => {
          // on cancel
        });
    },
    // 推荐/取消推荐接口
    recommendAdd(type, id) {
      if (this.$store.getters.states == "4") {
        this.$toast("您已被冻结");
        return;
      }
      let obj = {
        sellerProductGoodsId: id, //sellerProductGoodsId
        isRec: type == 0 ? "1" : "0", //1推荐， 0取消推荐
      };
      recommendAdd(obj).then((res) => {
        if (res.appStatus.errorCode == 0) {
          this.$toast(type == 0 ? "推荐成功" : "已取消推荐");
          this.$store.commit("user/SET_isRecommend", true);
          this.searchProduct(this.searchVal);
        }
      });
    },
    closeHandsel() {
      this.$router.go(-1);
    },
    getGoodsDesc(spgExId) {
      getGoodsDesc({
        spgExId, //商品推广文案的id
      }).then((res) => {
        if (res.appStatus.errorCode == 0) {
          this.description = res.content.description;
          this.copyTXT();
        }
      });
    },

    copyTXT() {
      var copyDOM = document.querySelector("#copy-txt"); //指定的DOM元素
      var range = document.createRange(); // 创建容器
      range.selectNode(copyDOM); // 选中需要复制的节点
      window.getSelection().addRange(range); // 执行选中元素
      var successful = document.execCommand("copy"); // 执行 copy 操作
      try {
        var msg = successful ? "复制成功" : "复制失败";
        // console.log("Copy was " + msg);
        this.$toast(msg)
      } catch (err) {
        // console.log("unable to copy");
      }
      window.getSelection().removeAllRanges(); // 移除选中的元素
    },
  },
  beforeRouteEnter(to, from, next) {
    if (from.path == "/goodsMsg") {
      to.meta.isBack = true;
    }
    next();
  },
  activated() {
    if (!this.$route.meta.isBack) {
      // 重置数据
      Object.assign(this.$data, this.$options.data.call(this));
      //   获取热门搜索纪录
      this.getHotKeyword();
      this.setHistory();
    }
    this.$route.meta.isBack = false;
  },
  computed: {
    // name() {
    //   // 返回视频名称
    //   return this.videoList.length > 0 ? this.videoList[0].cfpName : "";
    // }
  },
};
</script>
<style lang="scss" scoped>
$fs-color: #1d1d1d;
.searchconter {
  width: 100%;
  height: 100%;
  overflow: auto;
  background: #f4f4f4;
  // .searchs {
  //   width: 100%;
  //   height: auto;
  //   background: #f4f4f4;
  //   position: fixed;
  //   z-index: 99;
  //   .van-search {
  //     width: 100%;
  //     height: 50px;
  //     padding: 1.5px 15px;
  //     // position: sticky;
  //     .van-button {
  //       width: 60px;
  //       height: 30px;
  //       line-height: 30px;
  //       padding: 0;
  //       border-radius: 25px;
  //     }
  //   }
  // }
  .searchs {
    width: 100%;
    height: 44px;
    position: fixed;
    z-index: 99;
    display: flex;
    align-items: center;
    z-index: 99;
    background: #fff;
    i {
      color: #606060;
      font-size: 26px;
    }
    .van-search {
      padding: 2px 0;
      // position: fixed;
      width: 316px;
      z-index: 99;
      margin-left: 10px;
      .van-cell {
        padding: 4px;
      }
    }
    .van-button {
      width: 49px;
      height: 25px;
      padding: 0;
      border-radius: 16px;
      position: absolute;
      right: 15px;
      z-index: 88;
      i {
        color: #999;
        font-size: 16px;
      }
      .van-button__text {
        font-size: 12px;
        margin-left: 2px;
      }
    }
  }
  .record {
    width: 345px;
    height: calc(100% - 44px);
    // margin-top: 50px;
    padding: 0 15px;
    background: #fff;
    position: absolute;
    top: 44px;
    z-index: 2;
    > div {
      > p {
        display: flex;
        align-items: center;
        span {
          width: 100%;
          height: 50px;
          color: $fs-color;
          font-size: 14px;
          font-weight: bold;
          line-height: 50px;
          margin-right: auto;
        }
        i {
          font-size: 26px;
          color: #999;
        }
      }
      > div {
        display: flex;
        justify-content: start;
        flex-wrap: wrap;
        span {
          min-width: 28px;
          width: auto;
          height: 16px;
          padding: 6px 12px;
          background: #f5f5f5;
          border-radius: 15px;
          display: block;
          line-height: 16px;
          text-align: center;
          font-size: 12px;
          margin: 0 8px 8px 0;
        }
      }
    }
  }
  /deep/.listDiv {
    min-height: calc(100% - 44px);
    background: #f4f4f4;
    .glist {
      height: auto;
      margin-top: 44px;
      padding: 10px;
      > div {
        width: auto;
        padding: 10px;
        height: 141px;
        margin-bottom: 10px;
        .van-image {
          width: 141px;
          height: 141px;
          .van-image__img {
            border-radius: 5px;
          }
          // margin-right: 5px;
        }
        .overlys {
          width: 83px;
          height: 83px;
          line-height: 83px;
          top: 39px;
          left: 39px;
          span {
            font-size: 18px;
          }
        }
        .tags {
          width: 141px;
          height: 25px;
          line-height: 25px;
          top: 126px;
          left: 10px;
        }
        .gtexts {
          padding: 4px;
          > div {
            margin-top: 0;
          }
          .names {
            // min-height: 42px;
            text-overflow: ellipsis;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            word-break: break-all;
          }
        }
      }
    }
  }
  .searchList {
    width: 100%;
    height: calc(100% - 44px);
    // min-height: auto;
    position: absolute;
    z-index: 2;
    top: 44px;
    background: #fff;
    > div {
      width: auto;
      height: 50px;
      margin: 0 15px;
      line-height: 50px;
      font-size: 15px;
      border-bottom: 1.04px solid #f0f0f0;
      .searchVal {
        color: #ff1310;
      }
      > span:not(.searchVal) {
        color: #1d1d1d;
      }
    }
    > div:last-child {
      border-bottom: none;
    }
  }
  .nulls {
    width: 173px;
    margin: 184px auto 0;
    text-align: center;
    i {
      font-size: 100px;
      color: #d5d5d5;
    }
    p {
      color: #787878;
      font-size: 15px;
    }
    img{
      width: 80px;
      height: auto;
    }
  }
  .btn_group {
    display: flex;
    .van-button {
      padding: 0;
      border: 1.5px solid rgba(255, 81, 78, 1);
      border-radius: 25px;
    }
    .copy {
      width: 99px;
      height: 26px;
    }
  }

  #copy-txt {
    position:absolute;
    top:-999em;
    white-space: pre-line;
  }
}
</style>

